import { useCrudActions } from '@/common/view/useCrudActions';
import { giftService } from '@/services/gift';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const crudAction = useCrudActions();

    const model = reactive({
        sendLimit: 0,
        receiveLimit: 0,
        amount: 0
    });

    const validations = {
        sendLimit: { required, numeric, minValue: minValue(1) },
        receiveLimit: { required, numeric, minValue: minValue(1) },
        amount: { required, numeric, minValue: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: giftService().setting.get,
        onSuccess: ({ data }) => {
            model.sendLimit = data.sendLimit;
            model.receiveLimit = data.receiveLimit;
            model.amount = data.amount;
        },
        onError: () => {
            model.sendLimit = 0;
            model.receiveLimit = 0;
            model.amount = 0;
        }
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => giftService().setting.update(model.sendLimit, model.receiveLimit, model.amount),
        onSuccess: fetch
    });

    return { model, v$, fetch, update };
}
